import _ from 'lodash'

const matched = (target, needle) =>
  String(target)
    .toLowerCase()
    .indexOf(needle.toLowerCase()) !== -1

export default {
  /**
   * 配列から検索する
   * @param {array|object} target
   * @param {string} needle
   */
  searchFromCollection: function(target, needle) {
    return _.filter(target, (item) => {
      for (let i = 0; i < item.length; i++) {
        if (typeof item[i] === 'string' || typeof item[i] === 'number') {
          if (matched(item[i], needle)) return true
        }
        if (Array.isArray(item[i])) {
          item[i].forEach((row) => {
            Object.values(row).forEach((col) => {
              if (matched(col, needle)) return true
            })
          })
        }
        if (typeof item[i] === 'object') {
          if (item[i].type === 'input') {
            if (matched(item[i].inputValue, needle)) return true
          } else if (item[i] === 'select') {
            if (matched(item[i].selected, needle)) return true
          } else if (item[i].type === 'accordion') {
            if (matched(item[i].title, needle)) return true
            const bodyArray = item[i].body.split('　')
            const result = this.searchFromCollection(bodyArray, needle)
            if (result.length > 0) return true
          }
        }
      }
    })
  },
}
